export default __webpack_public_path__ + "static/media/redux.df7d6546.png";